const gateWay_url = process.env.REACT_APP_GATEWAY_URL;
const proxyGateway_url = process.env.REACT_APP_PROXY_GATEWAY_URL;
const fintech_gateway_url = process.env.REACT_APP_FINTECH_GATEWAY_URL;
const identity_gateway_url = process.env.REACT_APP_IDENTITY_GATEWAY_URL;

export const GET_CNIC_VERIFICATION = `${gateWay_url}/v1/commando/aggregator/user/profile/nationalid/all`;
export const GET_CNIC_IMAGE = `${gateWay_url}/v1/admin/document/image`;
export const VERIFY_CNIC = `${gateWay_url}/v1/commando/aggregator/user/lending/verification`;

export const CREATE_CAMPAIGN = `${gateWay_url}/v1/admin/campaign/create`;
export const GET_CAMPAIGN = `${gateWay_url}/v1/admin/campaign`;
export const UPDATE_CAMPAIGN = `${gateWay_url}/v1/admin/campaign/{campaign_id}`;

export const CREATE_WALLET = `${gateWay_url}/v1/care-coin/spreadsheet/customer`;
export const LOAD_WALLET = `${gateWay_url}/v1/care-coin/spreadsheet`;

export const STORE_TYPE = `${gateWay_url}/v1/customer/store/list-types`;
export const FETCH_STORE_CONFIG = `${gateWay_url}/v1/customer/store/admin/config`;
export const UPDATE_USER_PASSWORD = `${gateWay_url}/v2/identity/user/password/{userId}`;

export const FETCH_CUSTOMER_ZONE_URL = `${gateWay_url}/v1/zone`;

export const GET_STORES_URL = `${gateWay_url}/v1/customer/store/admin`;
export const GET_STORE_URL = `${gateWay_url}/v1/customer/admin/{store_id}`;
export const CREATE_STORE_URL = `${gateWay_url}/v1/customer/store/admin`;
export const UPDATE_STORE_URL = `${gateWay_url}/v1/customer/store/admin/{store_id}`;

export const GET_USERS_URL = `${gateWay_url}/v2/identity/user`;
export const GET_USER_URL = `${gateWay_url}/v2/identity/user/{user_id}`;
export const CREATE_USER_URL = `${gateWay_url}/v2/identity/user`;
export const UPDATE_USER_URL = `${gateWay_url}/v2/identity/user/details/{user_id}`;
export const UPDATE_USER_ACCESS_CONTROL_URL = `${gateWay_url}/v2/identity/user/{user_id}`;

export const GET_CUSTOMERS_V2_URL = `${gateWay_url}/v1/customer/store/admin`;
export const GET_USER_DETAIL_V2_URL = `${gateWay_url}/v2/identity/user/{user_id}`;
export const GET_MULTIPLE_USERS_DETAIL_V2_URL = `${gateWay_url}/v2/identity/user/users`;

export const GET_USER_BY_PHONE_NUMBER_V2_URL = `${gateWay_url}/v2/identity/user/phone/{phone_number}`;

export const GET_STORE_DETAIL_URL = `${gateWay_url}/v1/customer/store/admin/{store_id}`;

export const CREATE_GLOBAL_PRODUCT_URL = `${gateWay_url}/v1/admin/product/global`;
export const UPDATE_GLOBAL_PRODUCT_URL = `${gateWay_url}/v1/admin/product/global/{product_id}`;
export const GET_GLOBAL_PRODUCT_DETAILS_URL = `${gateWay_url}/v1/admin/product/global/{product_id}`;

export const GET_PRODUCT_TYPES_URL = `${gateWay_url}/v1/admin/product/type`;
export const GET_PRODUCT_BRANDS_URL = `${gateWay_url}/v1/catalog/brand/sub-brands`; // Need to test on Prod
export const GET_WAREHOUSE_URL = `${gateWay_url}/v1/inventory/warehouse`;

export const GET_UNIT_OF_MEASUREMENT_URL = `${gateWay_url}/v1/commando/aggregator/unit-of-measure`;

export const PRODUCT_BULK_UPLOAD_URL = `${gateWay_url}/v1/admin/product/upload`;
export const PRODUCT_INVENTORY_UPLOAD_URL = `${gateWay_url}/v1/inventory/product/upload`;
export const PRODUCT_INVENTORY_UPLOAD_V2_URL = `${gateWay_url}/warehouse/management/app/inventory/upload/inventory-caps`;
export const ZONAL_CONFIG_UPLOAD_URL = `${gateWay_url}/v1/inventory/product/upload`;
export const NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_URL = `${gateWay_url}/v3/catalog/product/price/upload`;

export const GET_CATEGORY_LIST_URL = `${gateWay_url}/v1/catalog/category/all`; //Used in multpile files.
export const FETCH_CATEGORY_LIST_FOR_CITY_URL = `${gateWay_url}/v1/admin/category/city/{cityId}`; //Used in multpile files.
export const FETCH_CATEGORY_PRODUCTS_FOR_CITY_URL = `${gateWay_url}/v1/admin/product/category/{categoryId}/city/{cityId}`; //Used in multpile files.
export const UPLOAD_IMAGE_URL = `${gateWay_url}/v1/admin/document/image/{entity}`; //Used in category city level
export const UPDATE_CITY_LEVEL_CATEGORY_URL = `${gateWay_url}/v1/admin/category/{categoryId}/city/{cityId}`; //Used in category city level
export const REORDER_CATEGORY_PRODUCTS_FOR_CITY = `${gateWay_url}/v1/admin/product/category/{categoryId}/city/{cityId}/reorder`; //Used in category city level
export const GET_BULK_PRODUCTS_BY_CATEGORY_IDS = `${gateWay_url}/v1/admin/product/global/bulk`; //Used in category city level

// FT-450 Create order validation commando aggregator service
export const CREATE_ORDER_URL = `${gateWay_url}/v1/commando/aggregator/order`;
export const GET_ORDERS_URL = `${gateWay_url}/v1/admin/order`;
export const GET_ORDERS_DETAILS_URL = `${gateWay_url}/v1/admin/order/{order_id}`;
export const UPDATE_ORDER_URL = `${gateWay_url}/v1/commando/aggregator/order/{order_id}`;
export const CHANGE_ORDER_STATUS_URL = `${gateWay_url}/v1/admin/order/{order_id}/status`;
export const FETCH_PRODUCT_FOR_ORDERS_URL = `${gateWay_url}/v3/sales/product`;
export const MINIMUM_ORDER_VALUE = `${gateWay_url}/v1/order/configuration/city/{cityId}`;

export const GET_ACCESS_CONTROL_USERS_URL = `${gateWay_url}/v2/identity/user`;
export const GET_PENDING_CUSTOMER_PROFILES_URL = `${fintech_gateway_url}/v1/bfs/customer/profile/nationalid/all`;
export const GET_ACCESS_CONTROL_USER_DETAIL_V2_URL = `${gateWay_url}/v2/identity/user/{user_id}`;

export const GET_ALL_CLIENTS_AND_ROLES_URL = `${gateWay_url}/v1/identity/access`;
export const ADD_REMOVE_USER_TO_CLIENT_URL = `${gateWay_url}/v1/identity/access/user/{user_id}/client`;
export const ADD_REMOVE_USER_TO_ROLE_URL = `${gateWay_url}/v1/identity/access/user/{user_id}/role`;

// Promo on orders
export const GET_ACTIVE_PROMOS_FOR_ORDER = `${gateWay_url}/v1/edge/promo`;

export const CHECK_PRODUCT_AVAILABILITY = `${gateWay_url}/v2/sales/product/refresh`;

export const ORDER_PRICE_BREAKDOWN = `${gateWay_url}/v1/payment/edge/breakdowns`;
export const FETCH_CITIES = `${gateWay_url}/v1/zone/zones`;
export const CREATE_AGENT_URL = `${gateWay_url}/v1/agent`;
export const UPDATE_AGENT_URL = `${gateWay_url}/v1/agent/{agent_id}`;
export const GET_AGENT_LIST_URL = `${gateWay_url}/v1/agent`;
export const GET_AGENT_TITLE_URL = `${gateWay_url}/v1/admin/agent/type`;
export const GET_AGENT_TEAM_URL = `${gateWay_url}/v1/admin/team`;
export const GET_AGENT_ZONES_URL = `${gateWay_url}/v2/zone/uc/active/channel?cityId={cityId}&customerChannel={customerChannel}`;
export const GET_BRAND_URL = `${gateWay_url}/v1/catalog/brand/sub-brands`;

//Temperory urls for testing purpose Stores
export const STORE_LISTING_BULK_UPLOAD_URL = `${gateWay_url}/v1/admin/agent/upload`;

export const GET_ODOO_TAX_LIST = `${gateWay_url}/v1/admin/tax/{tax_id}`;

// Tour Assignment
export const ASSIGN_TOUR_URL = `${gateWay_url}/v1/warehouse/aggregator/tour/tour-rider-assignment`;
// Tour Rider Assignment
export const REASSIGN_TOUR_URL = `${gateWay_url}/v1/fulfilment/tour/reassign-tour`;

export const ASSIGN_PLAN_URL = `${gateWay_url}/v1/fulfilment/plan/batch/assignment`;
export const CHECK_TOUR_ASSIGNMENT = `${gateWay_url}/v1/fulfilment/plan/unassigned-tour`;
export const UPLOAD_TOUR_CSV_URL = `${gateWay_url}/v1/warehouse/aggregator/tour/tour-rider-assignment/upload`;
export const UPLOAD_3PL_PLAN_TOURS_CSV_URL = `${gateWay_url}/v1/warehouse/aggregator/plan/create`;
export const CREATE_RIDER_URL = `${gateWay_url}/v1/rider`;
export const UPDATE_RIDER_URL = `${gateWay_url}/v1/rider/update`;
export const CHECK_RIDER_ASSIGNMENT = `${gateWay_url}/v1/warehouse/aggregator/fulfilment-rider/unassigned-rider`;
export const GET_RIDER_LIST_URL = `${gateWay_url}/v1/rider/all`;
export const RESET_DEVICE_URL = `${gateWay_url}/v1/rider/device/refresh-device`;
export const GET_DELIVERY_OPTIONS_URL = `${gateWay_url}/v1/fulfilment/plan/delivery-options`;

// Banners API
export const FETCH_BANNERS_URL = `${gateWay_url}/v1/catalog/banner/city/{cityId}/customer-channel/{customerChannel}`;
export const UPDATE_BANNER_URL = `${gateWay_url}/v1/catalog/banner`;
export const UPDATE_BANNER_PRODUCTS_URL = `${gateWay_url}/v1/catalog/banner/{banner_id}/products`;
export const UPDATE_BANNER_SEQUENCE_URL = `${gateWay_url}/v1/catalog/banner/city/{cityId}/sequence`;

// City level product urls
export const GET_PRODUCT_CITY_LEVEL_URL_V3 = `${gateWay_url}/v3/catalog/product/city`;
export const GET_PRODUCT_CITY_LEVEL_INVENTORY_URL = `${gateWay_url}/v1/inventory/product/{product_id}`;
export const UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_URL = `${gateWay_url}/v2/inventory/product`;
export const UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_URL_V2 = `${gateWay_url}/warehouse/management/app/inventory/caps`;

// Zone APIs
export const FETCH_UC_DETAILS_URL = `${gateWay_url}/v2/zone/{ucId}`;

// Global Category
export const GET_CATEGORY_GLOBAL_LIST_URL = `${gateWay_url}/v1/admin/category/global/all`;
export const CREATE_CATEGORY_GLOBAL_URL = `${gateWay_url}/v1/admin/category/global`;
export const GET_CORE_CATEGORY_GLOBAL_URL = `${gateWay_url}/v1/admin/category/core`;
export const UPDATE_CATEGORY_GLOBAL_URL = `${gateWay_url}/v1/admin/category/global`;
export const UNTAG_CATEGORY_ZONE_URL = `${gateWay_url}/v1/admin/category/check/UNTAG_CITY`;

export const LOGIN_URL = `${gateWay_url}/v2/auth/login`;

// MFA APIs
export const GET_MFA_SESSION_URL = `${gateWay_url}/v3/mfa/session`;
export const VALIDATE_MFA_URL = `${gateWay_url}/v3/mfa/validate`;
export const MFA_FALLBACK_URL = `${gateWay_url}/v3/mfa/initiate-fallback`;

export const CREATE_BASKET_PROMO_CITY_LEVEL_URL = `${gateWay_url}/v1/admin/promo/basket/city/{cityId}`;
export const CREATE_PROMO_CITY_LEVEL_URL = `${gateWay_url}/v1/admin/promo/city/{cityId}`;
export const CREATE_PROMO_BULK = `${gateWay_url}/v1/admin/promo/create`;
export const GET_PROMOS_CITY_LEVEL_URL = `${gateWay_url}/v1/admin/promo/city/{cityId}`;
export const GET_PROMO_CITY_LEVEL_DETAILS_URL = `${gateWay_url}/v1/admin/promo/detail/{promoId}`;
export const UPDATE_PROMO_CITY_LEVEL_STATUS_URL = `${gateWay_url}/v1/admin/promo/{promoid}/deactivate`;
export const GET_PROMO_CITY_LEVEL_BY_TYPE = `${gateWay_url}/v1/admin/promo/city/{cityId}/type/{promoType}`;
export const GET_LIST_OF_ACTIVE_PRODUCT_WITH_PROMO_CITY_LEVEL = `${gateWay_url}/v1/admin/promo/city/{cityId}/productId`;
export const GET_PROMO_CITY_LEVEL_PRODUCT_URL = `${gateWay_url}/v1/admin/product/city?cityId={cityId}`;

// Warehouse Operations
export const GET_WAREHOUSE_SHIFT = `${gateWay_url}/v1/warehouse/operations/shift?warehouseId={warehouse-id}`;
export const ADD_SHIFT_URL = `${gateWay_url}/v1/warehouse/operations/shift/start?warehouseId={warehouse-id}`;
export const UPDATE_SHIFT_URL = `${gateWay_url}/v1/warehouse/operations/shift/update-status?shiftId={shift-id}&eventType={event-type}`;
export const UPLOAD_TOUR_FOR_SHIFT_URL = `${gateWay_url}/v1/warehouse/aggregator/task/bulk/create?type={upload-type}&shiftId={shift-id}&warehouseId={warehouse-id}`;
export const UPLOAD_TOUR_FOR_SHIFT_URL_V2 = `${proxyGateway_url}/v2/warehouse/aggregator/task/bulk/create`;

//locus automation
export const DOWNLOAD_LOCUS_CSV_DUMP_URL = `${gateWay_url}/v1/control-tower/aggregator/plan-creation/locus`;
export const DOWNLOAD_PLAN_OUTPUT_CSV_DUMP_URL = `${gateWay_url}/v1/control-tower/aggregator/order/plan-details`;

//Rider Job Type
export const GET_RIDER_JOB_TYPES_URL = `${gateWay_url}/v1/rider/types`;

//Zonal Configurations
export const GET_ZONAL_CONFIG_URL = `${gateWay_url}/v3/zone/city/{cityId}`;
export const GET_ZONAL_CONFIG_CHANNEL_URL = `${gateWay_url}/v1/zone/partner/channel/uc/{ucId}`;
export const CREATE_ZONAL_CONFIG_URL = `${gateWay_url}/v1/warehouse/aggregator/zone`;
export const UPDATE_ZONAL_CONFIG_URL = `${gateWay_url}/v1/warehouse/aggregator/zone/{zone_type}/{zone_id}`;
export const GET_ZONAL_CONFIG_ZONES_URL = `${gateWay_url}/v2/zone/childZone/{parentZone_id}`;
export const GET_ZONAL_CONFIG_TOWNS_URL = `${gateWay_url}/v2/zone/childZone/{zone_id}`;
export const GET_ZONAL_CONFIG_WAREHOUSE_URL = `${gateWay_url}/v1/inventory/warehouse/zone/{zone_id}`;
export const ZONAL_CSV_BOUNDARY_UPLOAD_URL = `${gateWay_url}/v2/zone/batchupdate/{cityId}`;
export const ZONAL_CSV_SERVICE_AREA_UPLOAD_URL = `${gateWay_url}/v2/zone/service-area/batch-update/`;
export const GET_ZONAL_CONFIG_WAREHOUSE_STORAGE_BLOCK_URL = `${gateWay_url}/v1/inventory/warehouse/zone/details/{zone_id}`;

// Renew Token API URL
export const RENEW_ACCESS_TOKEN_URL = `${gateWay_url}/v3/auth/token/renew`;
export const RENEW_ACCESS_TOKEN_OIDC_URL = `${identity_gateway_url}/v4/oidc/token/renew`;

// Warehouse Delivery date Config URL
export const CREATE_UPDATE_DELIVERY_DATE_URL = `${gateWay_url}/v1/inventory/warehouse/delivery-config`;
export const FETCH_WAREHOUSE_DELIVERY_CONFIG = `${gateWay_url}/v1/inventory/warehouse/delivery-config/{warehouseId}`;

// Metrics
export const METRICS_CREATE_UPDATE_URL = `${gateWay_url}/v1/admin/team/metrics`;
export const METRICS_DETAILS_URL = `${gateWay_url}/v1/admin/team/metrics?cityId={cityId}`;
export const METRICS_GET_ALL_CORE_URL = `${gateWay_url}/v1/admin/team/all-core-metrics`;
export const METRICS_FETCH_CATEGORY_LIST_FOR_CITY_URL = `${gateWay_url}/v1/admin/category/all/city/{cityId}`;
export const METRICS_UPLOAD_URL = `${gateWay_url}/v1/admin/agent/upload/targets`;

// Paiya Page
// fetch paiya type based on cities
export const FETCH_PAIYA_TYPE = `${gateWay_url}/v1/game/config`;
// create paiya config
export const PAIYA_STORE_CSV_UPLOAD_URL = `${gateWay_url}/v1/game/PAIYA/{gameVariantType}/city/{cityId}/store`;
export const PAIYA_GIFT_CSV_UPLOAD_URL = `${gateWay_url}/v1/game/PAIYA/{gameVariantType}/city/{cityId}/gift`;
export const PAIYA_SET_MOV_GAME_STATUS = `${gateWay_url}/v1/game/PAIYA/{gameVariantType}/city/{cityId}`;
export const PAIYA_GET_MOV_GAME_STATUS = `${gateWay_url}/v1/game/PAIYA/{gameVariantType}/city/{cityId}`;

export const GET_WAREHOUSE_STAFF_LISTING = `${gateWay_url}/v1/warehouse/staff/all`;
export const GET_JOB_TYPES_URL = `${gateWay_url}/v1/warehouse/staff/job-types`;
export const WAREHOUSE_STAFF_URL = `${gateWay_url}/v1/warehouse/staff`;

//News Feed
export const GET_NEWSFEED_LIST_URL = `${gateWay_url}/v1/admin/post`;
export const CREATE_NEWSFEED_URL = `${gateWay_url}/v1/admin/post`;
export const UPDATE_NEWSFEED_URL = `${gateWay_url}/v1/admin/post/{postId}`;

//liveops page apis
export const UPDATE_DELIVERY_DATE_IN_LIVEOPS_URL = `${gateWay_url}/v1/control-tower/aggregator/order/delivery-date`;

//agent assignment page api
export const ASSIGN_AGENT_URL = `${gateWay_url}/v1/control-tower/aggregator/agent/assignment`;
//User Level Promo
export const UPLOAD_CSV_USER_LEVEL_TYPE_PROMO = `${gateWay_url}/v1/admin/promo/{promoId}/upload/users`;
export const GET_ACTIVE_UCS_BY_CITY_ID = `${gateWay_url}/v2/zone/uc/active?cityId={cityId}`;
export const GET_ALL_FILTERS_URL = `${gateWay_url}/v4/filter`;

export const CREATE_PAIYA_GIFT_URL = `${gateWay_url}/v1/gift`;
export const GET_PAIYA_GIFT_DETAILS_URL = `${gateWay_url}/v1/gift`;

export const CREATE_BULK_PROMO_URL = `${gateWay_url}/v1/admin/promo/{promoType}/create`;
export const UPDATE_PROMO_CITY_LEVEL_URL = `${gateWay_url}/v1/admin/promo/{promoid}/update`;
export const DEACTIVATE_BULK_PROMO_URL = `${gateWay_url}/v1/admin/promo/bulk/deactivation`;

// Credit Urls
export const GET_USER_CREDIT_LIMIT = `${fintech_gateway_url}/v1/lending/transaction/admin/limit`;
export const GET_CREDIT_PAYMENT_PLANS = `${fintech_gateway_url}/v1/lending/transaction/admin/plans`;
export const GET_CREDIT_USER = `${fintech_gateway_url}/v1/lending/onboarding/edge/status/{userId}`;

export const ACCESS_TOKEN_GENERATION_URI = `${identity_gateway_url}/v4/oidc/exchange/code`;
